"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.companyDesignListApi = companyDesignListApi;
exports.companyappApi = companyappApi;
exports.deleteApi = deleteApi;
exports.disableState = disableState;
exports.enableState = enableState;
exports.saveApi = saveApi;
exports.updateApi = updateApi;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * 归属小程序
 */
function companyappApi(params) {
  // return request({
  //     url: '/admin/companyapp/autoList',
  //     method: 'GET',
  //     params,
  // });
  return requestMapi({
    url: '/mapi/user/admin/company-app/autoList',
    method: 'get',
    params: params
  });
}

/**
 * 分页列表
 */
function companyDesignListApi(params) {
  // return request({
  //     url: '/admin/company-design/list',
  //     method: 'GET',
  //     params,
  // });
  return requestMapi({
    url: '/mapi/user/admin/company-app/autoList',
    method: 'get',
    params: params
  });
}

/**
 * 新增
 */
function saveApi(data) {
  return (0, _request.default)({
    url: '/admin/company-design/save',
    method: 'POST',
    data: data
  });
}

/**
 * 删除
 */
function deleteApi(params) {
  return (0, _request.default)({
    url: '/admin/company-design/delete',
    method: 'GET',
    params: params
  });
}

/**
 * 修改
 */
function updateApi(data) {
  return (0, _request.default)({
    url: '/admin/company-design/update',
    method: 'POST',
    data: data
  });
}

/**
 * 禁用
 */
function disableState(params) {
  return (0, _request.default)({
    url: '/admin/company-design/disable',
    method: 'get',
    params: params
  });
}

/**
 * 启用
 */
function enableState(params) {
  return (0, _request.default)({
    url: '/admin/company-design/enable',
    method: 'get',
    params: params
  });
}